import { render, staticRenderFns } from "./ReservationDictionary.vue?vue&type=template&id=1cf60084&scoped=true&"
import script from "./ReservationDictionary.vue?vue&type=script&lang=js&"
export * from "./ReservationDictionary.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDictionary.vue?vue&type=style&index=0&id=1cf60084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf60084",
  null
  
)

export default component.exports